import BaseTenantEdit from "../../../Boilerplate/AdminTenants/TenantEdit";
import { useMarketplaces } from "../_Shared/useMarketplaces";
import { creditTypeLabel } from "../utils/skus";
import SkuOfferEditor from "./SkuOfferEditor";
import TenantDrips from "./TenantDrips";

export default function TenantEdit(props) {
  const { marketplaces } = useMarketplaces();
  return (
    <BaseTenantEdit
      {...props}
      formatCreditType={(type) => creditTypeLabel(type, marketplaces)}
      creditsHint="100 credits = 1 SKU. Partner trial types grow the SKU pool."
      extra={
        <>
          <SkuOfferEditor tenantId={props.params.id} />
          <TenantDrips key={props.params.id} tenantId={props.params.id} />
        </>
      }
    />
  );
}
